/**
 * Client360 Этап 6 «Профіль» — uk label maps for the surface (mirrors the
 * backend enum options in CClientBusinessProfile / CClientHolding i18n).
 */

export const PROFILE_SURFACE_LABEL: Record<string, string> = {
  commercial: "Бізнес-профіль",
  breeder: "Профіль заводчика",
  neutral: "Технічний запис",
  unclassified: "Не класифіковано",
};

export const VERIFY_STATE_LABEL: Record<string, string> = {
  empty: "не заповнено",
  draft: "чернетка",
  needs_review: "очікує перевірки",
  verified: "перевірено",
  stale: "потребує оновлення",
};

export const VERIFY_STATE_TONE: Record<string, string> = {
  empty: "muted",
  draft: "blue",
  needs_review: "amber",
  verified: "green",
  stale: "amber",
};

export const PERSON_TYPE_LABEL: Record<string, string> = {
  real_holding: "Холдинг",
  single_entity: "Організація",
  purchasing_group: "Закупівельна група",
  franchise_group: "Франчайзингова група",
  family_business: "Сімейний бізнес",
  other: "Інше",
};

export const DECISION_MODEL_LABEL: Record<string, string> = {
  owner_led: "Власник одноосібно",
  buyer_led: "Закупівельник",
  corporate_procurement: "Корпоративні закупівлі",
  family_business: "Сімейний бізнес",
  franchise_rules: "Правила франшизи",
  vet_specialist_influenced: "Вплив ветспеціаліста",
  unknown: "Невідомо",
};

export const PURCHASING_MODEL_LABEL: Record<string, string> = {
  owner_buys: "Закуповує власник",
  dedicated_buyer: "Окремий закупівельник",
  centralized_procurement: "Централізовані закупівлі",
  outlet_level_purchasing: "Закупівлі на рівні точок",
  accountant_gatekeeper: "Через бухгалтера",
  mixed: "Змішана",
  unknown: "Невідомо",
};

export const ORDER_FREQUENCY_LABEL: Record<string, string> = {
  weekly: "Щотижня",
  biweekly: "Раз на 2 тижні",
  monthly: "Щомісяця",
  irregular: "Нерегулярно",
  seasonal: "Сезонно",
  unknown: "Невідомо",
};

export const POTENTIAL_LABEL: Record<string, string> = {
  low: "Низький",
  medium: "Середній",
  high: "Високий",
  strategic: "Стратегічний",
};

export const BUSINESS_SCALE_LABEL: Record<string, string> = {
  micro_1pt: "Мікро (1 точка)",
  small_2_3pts: "Малий (2–3 точки)",
  medium_4_10pts: "Середній (4–10 точок)",
  large_11plus: "Великий (11+ точок)",
  strategic_chain: "Стратегічна мережа",
};

export const COMPETITOR_BRAND_LABEL: Record<string, string> = {
  royal_canin: "Royal Canin",
  mars: "Mars",
  hills: "Hill's",
  acana_orijen: "Acana / Orijen",
  bozita: "Bozita",
  brit: "Brit",
  purina: "Purina",
  josera: "Josera",
  happy_dog: "Happy Dog",
  belcando: "Belcando",
  other: "Інше",
};

export const ASSORTMENT_LABEL: Record<string, string> = {
  dog_food: "Корми для собак",
  cat_food: "Корми для котів",
  vet_diets: "Ветдієти",
  treats: "Ласощі",
  accessories: "Аксесуари",
  grooming_products: "Грумінг-товари",
  hygiene: "Гігієна",
  aquarium: "Акваріумістика",
  small_pets: "Дрібні тварини",
  breeder_products: "Товари для заводчиків",
  premium_segment: "Преміум-сегмент",
  economy_segment: "Економ-сегмент",
};

export const ANIMAL_TYPE_LABEL: Record<string, string> = {
  dogs: "Собаки",
  cats: "Коти",
};

export const COUNT_BAND_LABEL: Record<string, string> = {
  "1_5": "1–5",
  "6_10": "6–10",
  "11_20": "11–20",
  "21_50": "21–50",
  "50_plus": "50+",
};

export const ADDITIONAL_ACTIVITY_LABEL: Record<string, string> = {
  grooming: "Грумінг",
  vet_services: "Ветпослуги",
  online_sales: "Онлайн-продажі",
  wholesale: "Опт",
  retail_points: "Роздрібні точки",
  breeding: "Розведення",
  marketplace_sales: "Маркетплейси",
  training_events: "Навчання / події",
  other: "Інше",
};

export const SCENARIO_LABEL: Record<string, string> = {
  retail: "Зоомагазин / роздріб",
  wholesale: "Опт",
  dealer: "Дилер",
  breeder: "Заводчик",
  deferred: "Інше",
};

export const STALE_REASON_LABEL: Record<string, string> = {
  time_elapsed: "Не оновлювався тривалий час",
  record_type_changed: "Змінився тип запису",
  business_model_changed: "Змінилася бізнес-модель",
  bi_signal: "BI-сигнал",
  manual_supervisor: "Вручну (supervisor)",
};

export const SCENARIO_ANSWER_LABEL: Record<string, string> = {
  storeFormat: "Формат магазину",
  outletsCountRange: "Кількість точок",
  hasOnlineSales: "Онлайн-продажі",
  customerSegment: "Сегмент клієнтів",
  mainCategories: "Основні категорії",
  hasGroomingOrVetCorner: "Грумінг / веткуточок",
  dominantShelfBrands: "Домінантні бренди на полиці",
  assortmentExpansionPotential: "Потенціал розширення асортименту",
  scenarioManagerComment: "Коментар менеджера",
  resellsTo: "Кому перепродає",
  resaleGeography: "Географія перепродажу",
  hasOwnClientBase: "Власна клієнтська база",
  alsoSellsRetail: "Також роздріб",
  mainResaleCategories: "Основні категорії перепродажу",
  competesWithKormax: "Конкурує з Kormax",
  promotedBrands: "Просувані бренди",
  dealerType: "Тип дилера",
  territoryCoverage: "Покриття території",
  worksWithEndCustomers: "Працює з кінцевими клієнтами",
  worksWithB2B: "Працює з B2B",
  representedBrands: "Представлені бренди",
  exclusivity: "Ексклюзивність",
  promotionActivity: "Промо-активність",
  needsPOSM: "Потребує POSM",
  animalType: "Тип тварин",
  breeds: "Породи",
  kennelName: "Назва розплідника",
  animalsCountRange: "Поголів'я",
  littersPerYear: "Помети на рік",
  givesStarterRecommendations: "Дає стартові рекомендації",
  currentFoodBrand: "Поточний бренд корму",
  breederProgramStatus: "Статус програми заводчика",
  recommendationPotential: "Потенціал рекомендацій",
};

/** Humanize an unmapped scenario answer key (camelCase → words). */
export function humanizeKey(key: string): string {
  return SCENARIO_ANSWER_LABEL[key]
    ?? key.replace(/([A-Z])/g, " $1").replace(/^./, (c) => c.toUpperCase());
}

/** Stringify a scenario answer value for display. */
export function answerValue(v: unknown): string {
  if (v === null || v === undefined || v === "") return "—";
  if (typeof v === "boolean") return v ? "Так" : "Ні";
  if (Array.isArray(v)) return v.map((x) => String(x)).join(" · ");
  return String(v);
}
